var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoingoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "287px",
    height: "141px",
    viewBox: "0 0 287 141",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.4928 47.2349033 0.4928 47.2349033 69.8368107 0 69.8368107"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.4355 0.873 114.4545 0.873 114.4545 38.4209 0.4355 38.4209"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boingo-logo",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 51.127000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4419,34.8188 C30.8099,34.8288 35.1689,40.5288 35.1949,46.8388 C35.1689,53.1498 30.8099,58.8478 23.4419,58.8598 C16.0729,58.8478 11.7129,53.1498 11.6839,46.8388 C11.7129,40.5288 16.0729,34.8288 23.4419,34.8188 M26.0059,23.8398 C18.8779,23.8288 14.5459,26.7678 12.0399,29.4078 L12.0399,0.4928 L-0.0001,0.4928 L-0.0001,1.2078 L-0.0001,68.7748 L11.5069,68.7748 L11.5069,63.7118 C14.8769,67.9358 20.1069,69.8368 25.5319,69.8368 L25.5639,69.8368 C32.2829,69.8428 37.7459,67.3218 41.4799,63.1668 C45.2209,59.0148 47.2379,53.2648 47.2349,46.8388 C47.2349,40.4018 45.0809,34.6538 41.3359,30.5098 C37.5949,26.3628 32.2559,23.8358 26.0059,23.8398",
    id: "Fill-1",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.1616,97.9654 C66.1886,91.6564 70.5516,85.9564 77.9196,85.9454 C85.2856,85.9564 89.6466,91.6564 89.6736,97.9654 C89.6466,104.2774 85.2856,109.9744 77.9196,109.9864 C70.5516,109.9744 66.1886,104.2774 66.1616,97.9654 M94.7556,81.2954 C90.4456,77.2594 84.4946,74.9664 77.9196,74.9664 C71.3426,74.9664 65.3896,77.2594 61.0816,81.2954 C56.7706,85.3264 54.1196,91.1064 54.1236,97.9654 C54.1196,104.8274 56.7706,110.6044 61.0816,114.6354 C65.3896,118.6714 71.3426,120.9654 77.9196,120.9644 L77.9286,120.9644 C84.5006,120.9644 90.4476,118.6704 94.7556,114.6354 C99.0646,110.6044 101.7156,104.8274 101.7116,97.9654 C101.7156,91.1064 99.0646,85.3264 94.7556,81.2954",
    id: "Fill-4",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FEFEFE",
    points: "110.3667 76.7412 110.3667 119.9022 122.4057 119.9022 122.4057 76.0272 110.3667 76.0272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8634,62.3261 C108.8694,66.0931 112.0264,69.4011 116.2964,69.4071 C120.5204,69.4011 123.9004,66.3751 123.9084,62.3261 C123.9004,58.2791 120.5204,55.2551 116.2964,55.2471 C112.0264,55.2551 108.8694,58.5611 108.8634,62.3261 Z",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.7573,74.9683 C152.6313,74.9493 148.6163,77.6433 146.2903,81.1193 L146.2903,76.0273 L134.7843,76.0273 L134.7843,76.7413 L134.7843,119.9013 L146.8223,119.9013 L146.8223,96.0193 C146.8953,90.5483 149.2883,85.9853 155.8353,85.9463 C159.2793,85.9793 160.8643,87.6213 161.8513,89.9743 C162.8053,92.3333 162.9093,95.3803 162.9053,97.7013 L162.9053,119.9013 L174.9443,119.9013 L174.9443,92.3953 C174.9423,87.9543 173.9083,83.6153 171.3303,80.3443 C168.7543,77.0693 164.6233,74.9563 158.7573,74.9683",
    id: "Fill-10",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6812,97.7017 C219.6382,104.4447 215.2682,109.4167 207.7492,109.4567 C200.9732,109.4507 196.0012,104.2167 195.9932,97.8767 C196.0332,90.7017 200.7552,85.9847 207.8372,85.9447 C215.1912,85.9907 219.6352,90.6907 219.6812,97.7017 Z M219.6812,76.0267 L219.6812,81.0927 C216.3052,76.8607 211.0632,74.9617 205.6262,74.9677 C198.9082,74.9627 193.4452,77.4817 189.7092,81.6377 C185.9712,85.7887 183.9552,91.5407 183.9552,97.9657 C183.9552,104.1437 186.1142,109.7637 189.9402,113.8407 C193.7612,117.9197 199.2532,120.4367 205.8052,120.4327 C210.7072,120.4307 215.7842,118.7617 219.1492,115.2627 L219.1492,116.6257 C219.1522,120.7437 218.3622,124.1287 216.4402,126.4417 C214.5242,128.7477 211.4282,130.1427 206.4222,130.1507 C200.6832,130.1407 196.4882,128.0477 192.3132,124.2357 L191.7252,123.6967 L184.5032,133.5297 L184.9922,133.9617 C191.1572,139.4047 198.5222,141.1267 206.4682,141.1267 L206.5112,141.1267 C214.9102,141.1327 221.1422,138.6397 225.2252,134.1157 C229.3082,129.5937 231.1912,123.1437 231.1912,115.3887 L231.1912,76.0267 L230.4782,76.0267 L219.6812,76.0267 Z",
    id: "Fill-12",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1968,109.9864 C255.8268,109.9764 251.4668,104.2784 251.4398,97.9664 C251.4668,91.6554 255.8268,85.9564 263.1968,85.9444 C270.5618,85.9564 274.9248,91.6554 274.9508,97.9664 C274.9248,104.2784 270.5618,109.9764 263.1968,109.9864 M280.0328,81.2964 C275.7228,77.2604 269.7738,74.9674 263.1968,74.9674 C256.6198,74.9674 250.6678,77.2604 246.3578,81.2964 C242.0488,85.3274 239.3978,91.1054 239.4008,97.9664 C239.3978,104.8264 242.0488,110.6054 246.3578,114.6364 C250.6678,118.6734 256.6198,120.9654 263.1968,120.9654 C269.7738,120.9654 275.7228,118.6734 280.0328,114.6364 C284.3428,110.6054 286.9928,104.8264 286.9898,97.9664 C286.9928,91.1054 284.3428,85.3274 280.0328,81.2964",
    id: "Fill-14",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(59.000000, 0.127000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8975,35.2109 C19.1045,19.1409 37.0135,8.4789 57.4475,8.4809 C77.8795,8.4789 95.7875,19.1409 105.9915,35.2089 L108.0305,38.4209 L114.4545,34.3439 L112.4165,31.1309 C100.8875,12.9589 80.5735,0.8729 57.4475,0.8729 C34.3185,0.8729 14.0045,12.9589 2.4755,31.1309 L0.4355,34.3439 L6.8595,38.4209 L8.8975,35.2109 Z",
    id: "Fill-16",
    fill: "#D52B1E",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.9751,53.774 L140.9361,50.564 C135.8061,42.471 126.7461,37.085 116.4461,37.085 C106.1451,37.085 97.0821,42.471 91.9541,50.564 L89.9161,53.776 L96.3401,57.854 L98.3791,54.642 L98.3771,54.642 C102.1831,48.657 108.8401,44.691 116.4461,44.692 C124.0521,44.691 130.7051,48.657 134.5121,54.64 L136.5511,57.852 L142.9751,53.774 Z",
    id: "Fill-19",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4458,19.041 C99.7318,19.041 85.0448,27.778 76.7138,40.913 L74.6758,44.123 L81.0998,48.2 L83.1378,44.988 C90.1438,33.961 102.4268,26.647 116.4458,26.649 C130.4658,26.647 142.7478,33.963 149.7508,44.988 L151.7888,48.2 L158.2138,44.125 L156.1758,40.913 C147.8468,27.778 133.1598,19.041 116.4458,19.041",
    id: "Fill-21",
    fill: "#D52B1E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoingoLogo);
export default __webpack_public_path__ + "static/media/boingo_logo.49eb6b597bd6e2d3c4fdbf11edebb732.svg";
export { ForwardRef as ReactComponent };